import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	NAV_STYLE_DRAWER,
	NAV_STYLE_FIXED,
	NAV_STYLE_MINI_SIDEBAR,
	NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
	TAB_SIZE,
	THEME_TYPE_LITE
} from '../../constants/ThemeSetting';

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }: any) => {
	const { width, themeType } = useSelector(({ settings }: any) => settings);
	let navStyle = useSelector(({ settings }: any) => settings.navStyle);
	if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
		navStyle = NAV_STYLE_DRAWER;
	}
	return (
		<div className="gx-layout-sider-header" >
			{navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR ? (
				<div className="gx-linebar">
					<i
						style={{ height: '26px' }}
						className={`gx-icon-btn icon icon-${!sidebarCollapsed ? 'menu-unfold' : 'menu-fold'} ${
							themeType !== THEME_TYPE_LITE ? 'gx-text-white' : ''
						}`}
						onClick={() => {
							setSidebarCollapsed(!sidebarCollapsed);
						}}
					/>
				</div>
			) : null}

			<Link to="#" className="gx-site-logo">
				{navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE ? (
					<img alt="lo" src={'/assets/images/robot.gif'} />
				) : themeType === THEME_TYPE_LITE ? (
					<img alt="logo1" src={'/assets/images/logowhite.png'} width={100} />
				) : (
					<img alt="logo2" src={'/assets/images/logowhite.png'} width={80} />
				)}
				{/* <span>ISF Video</span> */}
			</Link>
		</div>
	);
};

export default SidebarLogo;
